



import Component from 'vue-class-component'
import {SelectModel} from '@/services/types'
import DefaultSelect from '@/components/lib/select/DefaultSelect.vue'
import {RatingSelectProps} from './IRatingSelect'

@Component({
    components: {
        DefaultSelect
    }
})
export default class RatingSelect extends RatingSelectProps {

    private componentClass = "RatingSelect"

    private options: SelectModel [] = []

    private created() {
        for(let i=0; i<= this.max; i++) {
            this.options.push({
                value: i.toString(),
                text: i.toString()
            })
        }
    }

}
